// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const InvoicingForm = () => {
//     const now = new Date();
//     const formattedNow = now.toISOString().slice(0, 16);

//     const [formData, setFormData] = useState({
//         invoiceNumber: '',
//         customer: '',
//         email: '',
//         phone: '',
//         billingAddress: '',
//         shippingAddress: '',
//         gstin: '',
//         date: formattedNow,
//         dueDate: formattedNow,
//         items: [{ description: '', qty: '', rate: '' }],
//         status: 'Draft'
//     });

//     const [customers, setCustomers] = useState([]); // Store INTERESTED leads

//     // Fetch interested customers when the form loads
//     useEffect(() => {
//         const fetchLeads = async () => {
//             try {
//                 const user = JSON.parse(sessionStorage.getItem("userData"));
//                 if (!user?.id) {
//                     console.warn("User ID not found in sessionStorage");
//                     return;
//                 }
//                 const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
//                     params: { user_id: user.id }
//                 });
//                 const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
//                 setCustomers(interestedLeads);
//             } catch (err) {
//                 console.error('Error fetching leads:', err);
//             }
//         };
//         fetchLeads();
//     }, []);

//     // Handle normal input change
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     // Handle selecting customer from dropdown
//     const handleCustomerSelect = (e) => {
//         const selectedId = e.target.value;
//         const selectedCustomer = customers.find(c => c.id.toString() === selectedId);

//         if (selectedCustomer) {
//             setFormData(prev => ({
//                 ...prev,
//                 customer: selectedCustomer.name || "",
//                 email: selectedCustomer.email || "",
//                 phone: selectedCustomer.contact || "",
//                 gstin: selectedCustomer.gst || "",
//                 billingAddress: selectedCustomer.location || "",
//                 shippingAddress: selectedCustomer.location || ""
//             }));
//         }
//     };

//     // Handle item changes
//     const handleItemChange = (index, field, value) => {
//         const newItems = [...formData.items];
//         newItems[index][field] = field === 'qty' || field === 'rate' ? Number(value) : value;
//         setFormData(prev => ({ ...prev, items: newItems }));
//     };

//     // Add or remove item rows
//     const addItem = () => {
//         setFormData(prev => ({ ...prev, items: [...prev.items, { description: '', qty: 1, rate: 0 }] }));
//     };
//     const removeItem = (index) => {
//         const newItems = formData.items.filter((_, i) => i !== index);
//         setFormData(prev => ({ ...prev, items: newItems }));
//     };

//     // Calculations
//     const calculateSubtotal = () => formData.items.reduce((acc, item) => acc + item.qty * item.rate, 0);
//     const calculateGST = () => calculateSubtotal() * 0.18;
//     const calculateTotal = () => calculateSubtotal() + calculateGST();

//     // Submit
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const user = JSON.parse(sessionStorage.getItem("userData"));
//             if (!user?.id) {
//                 alert("User not logged in");
//                 return;
//             }
//             const payload = { ...formData, user_id: user.id };
//             const response = await axios.post("https://cloudapi.emedhatechnologies.com/pages/api/api/invoices", payload);
//             console.log(response.data);
//             alert("Invoice saved successfully!");
//             const now = new Date();
//             const formattedNow = now.toISOString().slice(0, 16);
//             setFormData({
//                 invoiceNumber: '',
//                 customer: '',
//                 email: '',
//                 phone: '',
//                 billingAddress: '',
//                 shippingAddress: '',
//                 gstin: '',
//                 date: formattedNow,
//                 dueDate: formattedNow,
//                 items: [{ description: '', qty: '', rate: '' }],
//                 status: 'Draft'
//             });
//         } catch (err) {
//             console.error("Error saving invoice:", err);
//             alert("Failed to save invoice.");
//         }
//     };



//     // Reusable input and textarea
//     const renderInput = (label, name, type = "text", value = "", onChange) => (
//         <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>{label}</label>
//             <input name={name} type={type} value={value} onChange={onChange} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} />
//         </div>
//     );
//     const renderTextarea = (label, name, value, onChange) => (
//         <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>{label}</label>
//             <textarea name={name} value={value} onChange={onChange} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", minHeight: '60px', resize: 'vertical' }} />
//         </div>
//     );

//     return (
//         <div style={{ margin: 'auto', }}>
//             <h2 style={{ marginBottom: '10px', fontSize: '16px', fontWeight: 'bold' }}>Invoice Form :</h2>
//             <form onSubmit={handleSubmit} style={{ background: '#f9f9f9', padding: '10px', border: '1px solid #ddd', borderRadius: '10px' }}>
//                 {/* Invoice Info */}
//                 <div style={{ marginBottom: '20px' }}>
//                     <h4 style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Invoice Details :</h4>
//                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
//                         {renderInput("Invoice Number", "invoiceNumber", "text", formData.invoiceNumber, handleInputChange)}
//                         {renderInput("Invoice Date", "date", "datetime-local", formData.date, handleInputChange)}
//                         {renderInput("Due Date", "dueDate", "datetime-local", formData.dueDate, handleInputChange)}
//                         {/* Status dropdown */}
//                         <div style={{ display: 'flex', flexDirection: 'column' }}>
//                             <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>Status</label>
//                             <select name="status" value={formData.status} onChange={handleInputChange} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }}>
//                                 <option value="Draft">Draft</option>
//                                 <option value="Sent">Sent</option>
//                                 <option value="Paid">Paid</option>
//                             </select>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Customer Info */}
//                 <div style={{ marginBottom: '20px' }}>
//                     <h4 style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Customer Info :</h4>
//                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
//                         {/* Dropdown for interested customers */}
//                         <div style={{ display: 'flex', flexDirection: 'column' }}>
//                             <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>Select Customer</label>
//                             <select onChange={handleCustomerSelect} value={customers.find(c => c.name === formData.customer)?.id || ''} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }}>
//                                 <option value="">-- Select Customer --</option>
//                                 {customers.map(cust => (
//                                     <option key={cust.id} value={cust.id}>{cust.name}</option>
//                                 ))}
//                             </select>
//                         </div>
//                         {renderInput("Email", "email", "email", formData.email, handleInputChange)}
//                         {renderInput("Phone", "phone", "text", formData.phone, handleInputChange)}
//                         {renderInput("GSTIN", "gstin", "text", formData.gstin, handleInputChange)}
//                         {renderTextarea("Billing Address", "billingAddress", formData.billingAddress, handleInputChange)}
//                         {renderTextarea("Shipping Address", "shippingAddress", formData.shippingAddress, handleInputChange)}
//                     </div>
//                 </div>

//                 {/* Items Section */}
//                 <div style={{ marginBottom: '20px' }}>
//                     <h4 style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Items :</h4>
//                     {formData.items.map((item, index) => (
//                         <div key={index} style={{ display: 'grid', gridTemplateColumns: '4fr 1fr 1fr 1fr auto', gap: '10px', marginBottom: '10px' }}>
//                             <div style={{ display: 'flex', flexDirection: 'column' }}>
//                                 <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>Description</label>
//                                 <input value={item.description} onChange={e => handleItemChange(index, 'description', e.target.value)} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} />
//                             </div>
//                             <div style={{ display: 'flex', flexDirection: 'column' }}>
//                                 <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>Qty</label>
//                                 <input type="number" value={item.qty} onChange={e => handleItemChange(index, 'qty', e.target.value)} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} />
//                             </div>
//                             <div style={{ display: 'flex', flexDirection: 'column' }}>
//                                 <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>Rate</label>
//                                 <input type="number" value={item.rate} onChange={e => handleItemChange(index, 'rate', e.target.value)} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} />
//                             </div>
//                             <div style={{ display: 'flex', flexDirection: 'column' }}>
//                                 <label style={{ marginBottom: '4px', fontSize: '12px', fontWeight: 'bold' }}>Amount</label>
//                                 <input type="text" value={(item.qty * item.rate).toFixed(2)} disabled style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} />
//                             </div>
//                             <button type="button" onClick={() => removeItem(index)} style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>X</button>
//                         </div>
//                     ))}
//                     <button type="button" onClick={addItem} style={{ backgroundColor: '#007bff', color: '#fff', padding: '5px 10px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>+ Add Item</button>
//                 </div>

//                 {/* Totals */}
//                 <div style={{ marginTop: '20px', textAlign: 'right' }}>
//                     <p><strong>Subtotal:</strong> ₹{calculateSubtotal().toFixed(2)}</p>
//                     <p><strong>GST (18%):</strong> ₹{calculateGST().toFixed(2)}</p>
//                     <p><strong>Total:</strong> ₹{calculateTotal().toFixed(2)}</p>
//                 </div>

//                 <button type="submit" style={{ marginTop: '20px', backgroundColor: '#28a745', color: '#fff', padding: '10px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Save Invoice</button>
//             </form>
//         </div>
//     );
// };

// export default InvoicingForm;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import {
//   Plus, FileText, Building2,
//   Calendar, Hash, Save, X, Mail, Phone as PhoneIcon, Landmark
// } from 'lucide-react';

// const InvoicingForm = () => {
//     const now = new Date();
//     const formattedNow = now.toISOString().slice(0, 16);

//     const [formData, setFormData] = useState({
//         invoiceNumber: '',
//         customer: '',
//         email: '',
//         phone: '',
//         billingAddress: '',
//         shippingAddress: '',
//         gstin: '',
//         date: formattedNow,
//         dueDate: formattedNow,
//         items: [{ description: '', qty: '', rate: '' }],
//         status: 'Draft'
//     });

//     const [customers, setCustomers] = useState([]); // Store INTERESTED leads

//     // Fetch interested customers when the form loads
//     useEffect(() => {
//         const fetchLeads = async () => {
//             try {
//                 const user = JSON.parse(sessionStorage.getItem("userData"));
//                 if (!user?.id) {
//                     console.warn("User ID not found in sessionStorage");
//                     return;
//                 }
//                 const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
//                     params: { user_id: user.id }
//                 });
//                 const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
//                 setCustomers(interestedLeads);
//             } catch (err) {
//                 console.error('Error fetching leads:', err);
//             }
//         };
//         fetchLeads();
//     }, []);

//     // Handle normal input change
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     // Handle selecting customer from dropdown
//     const handleCustomerSelect = (e) => {
//         const selectedId = e.target.value;
//         const selectedCustomer = customers.find(c => c.id.toString() === selectedId);

//         if (selectedCustomer) {
//             setFormData(prev => ({
//                 ...prev,
//                 customer: selectedCustomer.name || "",
//                 email: selectedCustomer.email || "",
//                 phone: selectedCustomer.contact || "",
//                 gstin: selectedCustomer.gst || "",
//                 billingAddress: selectedCustomer.location || "",
//                 shippingAddress: selectedCustomer.location || ""
//             }));
//         }
//     };

//     // Handle item changes
//     const handleItemChange = (index, field, value) => {
//         const newItems = [...formData.items];
//         newItems[index][field] = field === 'qty' || field === 'rate' ? Number(value) : value;
//         setFormData(prev => ({ ...prev, items: newItems }));
//     };

//     // Add or remove item rows
//     const addItem = () => {
//         setFormData(prev => ({ ...prev, items: [...prev.items, { description: '', qty: 1, rate: 0 }] }));
//     };
//     const removeItem = (index) => {
//         const newItems = formData.items.filter((_, i) => i !== index);
//         setFormData(prev => ({ ...prev, items: newItems }));
//     };

//     // Calculations
//     const calculateSubtotal = () => formData.items.reduce((acc, item) => acc + item.qty * item.rate, 0);
//     const calculateGST = () => calculateSubtotal() * 0.18;
//     const calculateTotal = () => calculateSubtotal() + calculateGST();

//     // Submit
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const user = JSON.parse(sessionStorage.getItem("userData"));
//             if (!user?.id) {
//                 alert("User not logged in");
//                 return;
//             }
//             const payload = { ...formData, user_id: user.id };
//             const response = await axios.post("https://cloudapi.emedhatechnologies.com/pages/api/api/invoices", payload);
//             console.log(response.data);
//             alert("Invoice saved successfully!");
//             const now = new Date();
//             const formattedNow = now.toISOString().slice(0, 16);
//             setFormData({
//                 invoiceNumber: '',
//                 customer: '',
//                 email: '',
//                 phone: '',
//                 billingAddress: '',
//                 shippingAddress: '',
//                 gstin: '',
//                 date: formattedNow,
//                 dueDate: formattedNow,
//                 items: [{ description: '', qty: '', rate: '' }],
//                 status: 'Draft'
//             });
//         } catch (err) {
//             console.error("Error saving invoice:", err);
//             alert("Failed to save invoice.");
//         }
//     };

//     // Shared UI Styling Variables
//     const cardStyle = {
//         backgroundColor: '#ffffff',
//         border: '1px solid #e5e5e5',
//         borderRadius: '16px',
//         padding: '20px',
//         boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//     };

//     const labelStyle = {
//         display: 'block',
//         fontSize: '12px',
//         fontWeight: '600',
//         color: '#737373',
//         textTransform: 'uppercase',
//         letterSpacing: '0.05em',
//         marginBottom: '4px'
//     };

//     const baseInputStyle = {
//         width: '100%',
//         padding: '8px 12px',
//         fontSize: '14px',
//         backgroundColor: '#f9f9f9',
//         border: '1px solid #e5e5e5',
//         borderRadius: '12px',
//         outline: 'none',
//         boxSizing: 'border-box',
//         transition: 'all 0.2s ease'
//     };

//     // Render Helpers matching your design requirement parameters
//     const renderStyledInput = (label, name, type = "text", value = "", onChange, iconElement = null) => (
//         <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <label style={labelStyle}>{label}</label>
//             <div style={{ position: 'relative' }}>
//                 {iconElement && (
//                     <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', color: '#a3a3a3', pointerEvents: 'none' }}>
//                         {iconElement}
//                     </div>
//                 )}
//                 <input
//                     name={name}
//                     type={type}
//                     value={value}
//                     onChange={onChange}
//                     style={{
//                         ...baseInputStyle,
//                         paddingLeft: iconElement ? '36px' : '12px'
//                     }}
//                 />
//             </div>
//         </div>
//     );

//     const renderStyledTextarea = (label, name, value, onChange) => (
//         <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <label style={labelStyle}>{label}</label>
//             <textarea
//                 name={name}
//                 value={value}
//                 onChange={onChange}
//                 rows={2}
//                 placeholder={`Enter standard operational ${label.toLowerCase()} layouts...`}
//                 style={{ ...baseInputStyle, resize: 'none' }}
//             />
//         </div>
//     );

//     return (
//         <div style={{ padding: '24px', maxWidth: '1024px', margin: '0 auto', backgroundColor: '#fafafa', minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            
//             {/* Design Header Row */}
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #f5f5f5', paddingBottom: '16px', marginBottom: '24px' }}>
//                 <div>
//                     <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#171717', margin: 0 }}>Invoice Form</h1>
//                     <p style={{ color: '#737373', fontSize: '14px', margin: '4px 0 0 0' }}>Create and modify client billing configurations</p>
//                 </div>
//             </div>

//             <form onSubmit={handleSubmit}>
//                 <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
                    
//                     {/* Left Form Blocks Group */}
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        
//                         {/* Section Block 1: Invoice Details */}
//                         <div style={cardStyle}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
//                                 <FileText style={{ width: '16px', height: '16px', color: '#2563eb' }} />
//                                 <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Invoice Details</h2>
//                             </div>

//                             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
//                                 {renderStyledInput("Invoice Number", "invoiceNumber", "text", formData.invoiceNumber, handleInputChange, <Hash style={{ width: '16px', height: '16px' }} />)}
//                                 {renderStyledInput("Invoice Date", "date", "datetime-local", formData.date, handleInputChange, <Calendar style={{ width: '16px', height: '16px' }} />)}
//                                 {renderStyledInput("Due Date", "dueDate", "datetime-local", formData.dueDate, handleInputChange, <Calendar style={{ width: '16px', height: '16px' }} />)}
                                
//                                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                                     <label style={labelStyle}>Status</label>
//                                     <div style={{ display: 'flex', backgroundColor: '#f5f5f5', padding: '4px', borderRadius: '12px', gap: '4px', height: '100%', boxSizing: 'border-box', alignItems: 'center' }}>
//                                         {['Draft', 'Sent', 'Paid'].map(s => (
//                                             <button
//                                                 key={s}
//                                                 type="button"
//                                                 onClick={() => setFormData(prev => ({ ...prev, status: s }))}
//                                                 style={{
//                                                     flex: 1,
//                                                     padding: '8px 0',
//                                                     fontSize: '12px',
//                                                     fontWeight: '500',
//                                                     borderRadius: '8px',
//                                                     border: 'none',
//                                                     cursor: 'pointer',
//                                                     transition: 'all 0.2s ease',
//                                                     backgroundColor: formData.status === s ? '#ffffff' : 'transparent',
//                                                     color: formData.status === s ? '#171717' : '#737373',
//                                                     boxShadow: formData.status === s ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none'
//                                                 }}
//                                             >
//                                                 {s}
//                                             </button>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Section Block 2: Customer Info */}
//                         <div style={cardStyle}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
//                                 <Building2 style={{ width: '16px', height: '16px', color: '#a855f7' }} />
//                                 <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Customer Info</h2>
//                             </div>

//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                                 <div>
//                                     <label style={labelStyle}>Select Customer</label>
//                                     <select 
//                                         onChange={handleCustomerSelect} 
//                                         value={customers.find(c => c.name === formData.customer)?.id || ''} 
//                                         style={baseInputStyle}
//                                     >
//                                         <option value="">-- Select Customer --</option>
//                                         {customers.map(cust => (
//                                             <option key={cust.id} value={cust.id}>{cust.name}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '16px' }}>
//                                     {renderStyledInput("Email", "email", "email", formData.email, handleInputChange, <Mail style={{ width: '16px', height: '16px' }} />)}
//                                     {renderStyledInput("Phone", "phone", "text", formData.phone, handleInputChange, <PhoneIcon style={{ width: '16px', height: '16px' }} />)}
//                                     {renderStyledInput("GSTIN", "gstin", "text", formData.gstin, handleInputChange, <Landmark style={{ width: '16px', height: '16px' }} />)}
//                                 </div>

//                                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
//                                     {renderStyledTextarea("Billing Address", "billingAddress", formData.billingAddress, handleInputChange)}
//                                     {renderStyledTextarea("Shipping Address", "shippingAddress", formData.shippingAddress, handleInputChange)}
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Section Block 3: Dynamic Matrix Items List */}
//                         <div style={cardStyle}>
//                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
//                                 <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Items</h2>
//                             </div>

//                             <div style={{ overflow: 'visible' }}>
//                                 <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
//                                     <thead>
//                                         <tr style={{ borderBottom: '1px solid #f5f5f5', color: '#737373', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
//                                             <th style={{ textAlign: 'left', paddingBottom: '8px', fontWeight: '500', width: '45%' }}>Description</th>
//                                             <th style={{ textAlign: 'center', paddingBottom: '8px', fontWeight: '500', width: '15%' }}>Qty</th>
//                                             <th style={{ textAlign: 'right', paddingBottom: '8px', fontWeight: '500', width: '20%' }}>Rate</th>
//                                             <th style={{ textAlign: 'right', paddingBottom: '8px', fontWeight: '500', width: '15%' }}>Amount</th>
//                                             <th style={{ paddingBottom: '8px', width: '5%' }} />
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {formData.items.map((item, index) => (
//                                             <tr key={index}>
//                                                 <td style={{ padding: '12px 8px 12px 0' }}>
//                                                     <input 
//                                                         value={item.description} 
//                                                         onChange={e => handleItemChange(index, 'description', e.target.value)} 
//                                                         placeholder="Item detail specification description..."
//                                                         style={{ ...baseInputStyle, padding: '6px 8px', backgroundColor: '#ffffff' }} 
//                                                     />
//                                                 </td>
//                                                 <td style={{ padding: '12px 8px' }}>
//                                                     <input 
//                                                         type="number" 
//                                                         value={item.qty} 
//                                                         onChange={e => handleItemChange(index, 'qty', e.target.value)} 
//                                                         style={{ ...baseInputStyle, padding: '6px 8px', textAlign: 'center', backgroundColor: '#ffffff' }} 
//                                                     />
//                                                 </td>
//                                                 <td style={{ padding: '12px 8px' }}>
//                                                     <input 
//                                                         type="number" 
//                                                         value={item.rate} 
//                                                         onChange={e => handleItemChange(index, 'rate', e.target.value)} 
//                                                         style={{ ...baseInputStyle, padding: '6px 8px', textAlign: 'right', backgroundColor: '#ffffff' }} 
//                                                     />
//                                                 </td>
//                                                 <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '500', color: '#262626' }}>
//                                                     ₹{((item.qty || 0) * (item.rate || 0)).toFixed(2)}
//                                                 </td>
//                                                 <td style={{ padding: '12px 0 12px 8px', textAlign: 'right' }}>
//                                                     <button 
//                                                         type="button" 
//                                                         onClick={() => removeItem(index)} 
//                                                         style={{ backgroundColor: 'transparent', color: '#f87171', border: 'none', padding: '4px', cursor: 'pointer', borderRadius: '6px' }}
//                                                     >
//                                                         <X style={{ width: '16px', height: '16px' }} />
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>

//                             <button 
//                                 type="button" 
//                                 onClick={addItem} 
//                                 style={{
//                                     marginTop: '16px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
//                                     gap: '6px', padding: '8px 0', border: '2px dashed #e5e5e5', borderRadius: '12px', fontSize: '12px',
//                                     fontWeight: '600', color: '#737373', backgroundColor: '#ffffff', cursor: 'pointer', transition: 'all 0.2s'
//                                 }}
//                             >
//                                 <Plus style={{ width: '14px', height: '14px' }} />
//                                 Add Item
//                             </button>
//                         </div>
//                     </div>

//                     {/* Right Side Computational Sticky Sidebar */}
//                     <div style={{ position: 'sticky', top: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
//                         <div style={cardStyle}>
//                             <h3 style={{ fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#a3a3a3', borderBottom: '1px solid #f5f5f5', paddingBottom: '8px', margin: '0 0 16px 0' }}>Summary</h3>
                            
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
//                                     <span style={{ color: '#737373' }}>Subtotal:</span>
//                                     <span style={{ fontWeight: '500', color: '#262626' }}>₹{calculateSubtotal().toFixed(2)}</span>
//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
//                                     <span style={{ color: '#737373' }}>GST (18%):</span>
//                                     <span style={{ fontWeight: '500', color: '#262626' }}>₹{calculateGST().toFixed(2)}</span>
//                                 </div>
                                
//                                 <div style={{ borderTop: '1px solid #f5f5f5', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <span style={{ fontSize: '14px', fontWeight: '700', color: '#171717' }}>Total:</span>
//                                     <span style={{ fontSize: '18px', fontWeight: '700', color: '#2563eb' }}>₹{calculateTotal().toFixed(2)}</span>
//                                 </div>
//                             </div>

//                             <div style={{ paddingTop: '8px', marginTop: '16px' }}>
//                                 <button 
//                                     type="submit" 
//                                     style={{
//                                         width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
//                                         padding: '10px 0', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '12px',
//                                         fontWeight: '500', fontSize: '14px', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//                                     }}
//                                 >
//                                     <Save style={{ width: '16px', height: '16px' }} />
//                                     Save Invoice
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </form>
//         </div>
//     );
// };

// export default InvoicingForm;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Plus, FileText, Building2,
  Calendar, Hash, Save, X, Mail, Phone as PhoneIcon, Landmark
} from 'lucide-react';

const InvoicingForm = () => {
    const now = new Date();
    const formattedNow = now.toISOString().slice(0, 16);

    const [formData, setFormData] = useState({
        invoiceNumber: '',
        customer: '',
        email: '',
        phone: '',
        billingAddress: '',
        shippingAddress: '',
        gstin: '',
        date: formattedNow,
        dueDate: formattedNow,
        items: [{ description: '', qty: '', rate: '' }],
        status: 'Draft'
    });

    const [customers, setCustomers] = useState([]); // Store INTERESTED leads

    // Fetch interested customers when the form loads
    useEffect(() => {
        const fetchLeads = async () => {
            try {
                const user = JSON.parse(sessionStorage.getItem("userData"));
                if (!user?.id) {
                    console.warn("User ID not found in sessionStorage");
                    return;
                }
                const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
                    params: { user_id: user.id }
                });
                const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
                setCustomers(interestedLeads);
            } catch (err) {
                console.error('Error fetching leads:', err);
            }
        };
        fetchLeads();
    }, []);

    // Handle normal input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle selecting customer from dropdown
    const handleCustomerSelect = (e) => {
        const selectedId = e.target.value;
        const selectedCustomer = customers.find(c => c.id.toString() === selectedId);

        if (selectedCustomer) {
            setFormData(prev => ({
                ...prev,
                customer: selectedCustomer.name || "",
                email: selectedCustomer.email || "",
                phone: selectedCustomer.contact || "",
                gstin: selectedCustomer.gst || "",
                billingAddress: selectedCustomer.location || "",
                shippingAddress: selectedCustomer.location || ""
            }));
        }
    };

    // Handle item changes
    const handleItemChange = (index, field, value) => {
        const newItems = [...formData.items];
        newItems[index][field] = field === 'qty' || field === 'rate' ? Number(value) : value;
        setFormData(prev => ({ ...prev, items: newItems }));
    };

    // Add or remove item rows
    const addItem = () => {
        setFormData(prev => ({ ...prev, items: [...prev.items, { description: '', qty: 1, rate: 0 }] }));
    };
    const removeItem = (index) => {
        const newItems = formData.items.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, items: newItems }));
    };

    // Calculations
    const calculateSubtotal = () => formData.items.reduce((acc, item) => acc + item.qty * item.rate, 0);
    const calculateGST = () => calculateSubtotal() * 0.18;
    const calculateTotal = () => calculateSubtotal() + calculateGST();

    // Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const user = JSON.parse(sessionStorage.getItem("userData"));
            if (!user?.id) {
                alert("User not logged in");
                return;
            }
            const payload = { ...formData, user_id: user.id };
            const response = await axios.post("https://cloudapi.emedhatechnologies.com/pages/api/api/invoices", payload);
            console.log(response.data);
            alert("Invoice saved successfully!");
            const now = new Date();
            const formattedNow = now.toISOString().slice(0, 16);
            setFormData({
                invoiceNumber: '',
                customer: '',
                email: '',
                phone: '',
                billingAddress: '',
                shippingAddress: '',
                gstin: '',
                date: formattedNow,
                dueDate: formattedNow,
                items: [{ description: '', qty: '', rate: '' }],
                status: 'Draft'
            });
        } catch (err) {
            console.error("Error saving invoice:", err);
            alert("Failed to save invoice.");
        }
    };

    // Shared UI Styling Variables
    const cardStyle = {
        backgroundColor: '#ffffff',
        border: '1px solid #e5e5e5',
        borderRadius: '16px',
        padding: '20px',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
    };

    const labelStyle = {
        display: 'block',
        fontSize: '12px',
        fontWeight: '600',
        color: '#737373',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: '4px'
    };

    const baseInputStyle = {
        width: '100%',
        padding: '10px 12px',
        fontSize: '14px',
        backgroundColor: '#f9f9f9',
        border: '1px solid #e5e5e5',
        borderRadius: '12px',
        outline: 'none',
        boxSizing: 'border-box',
        transition: 'all 0.2s ease',
    };

    const renderStyledInput = (label, name, type = "text", value = "", onChange, iconElement = null) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={labelStyle}>{label}</label>
            <div style={{ position: 'relative' }}>
                {iconElement && (
                    <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', color: '#a3a3a3', pointerEvents: 'none' }}>
                        {iconElement}
                    </div>
                )}
                <input
                    name={name}
                    type={type}
                    value={value}
                    onChange={onChange}
                    style={{
                        ...baseInputStyle,
                        paddingLeft: iconElement ? '36px' : '12px'
                    }}
                />
            </div>
        </div>
    );

    const renderStyledTextarea = (label, name, value, onChange) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={labelStyle}>{label}</label>
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                rows={3}
                style={{ ...baseInputStyle, resize: 'none' }}
            />
        </div>
    );

    return (
        <div className="invoice-container">
            {/* Inline CSS Block handling CSS Injection for true responsive breakpoints */}
            <style dangerouslySetInnerHTML={{__html: `
                .invoice-container {
                    // padding: 16px;
                    max-width: 1200px;
                    margin: 0 auto;
                    backgroundColor: #fafafa;
                    min-height: 100vh;
                    font-family: system-ui, -apple-system, sans-serif;
                }
                .main-layout {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 20px;
                    align-items: start;
                }
                .invoice-grid-fields {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 16px;
                }
                .customer-tier-fields {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 16px;
                }
                .address-fields {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 16px;
                }
                .item-row {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 12px;
                    padding: 16px 0;
                    border-bottom: 1px dashed #e5e5e5;
                }
                .item-row-inner-metrics {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr) auto;
                    gap: 12px;
                    align-items: end;
                }
                .desktop-table-header {
                    display: none;
                }
                .sticky-sidebar {
                    position: static;
                }

                /* Responsive Tablet Viewports (>= 768px) */
                @media (min-width: 768px) {
                    .invoice-container { padding: 24px; }
                    .invoice-grid-fields { grid-template-columns: repeat(2, 1fr); }
                    .customer-tier-fields { grid-template-columns: repeat(3, 1fr); }
                    .address-fields { grid-template-columns: repeat(2, 1fr); }
                    
                    .item-row {
                        grid-template-columns: 2fr 1fr 1fr 1fr auto;
                        align-items: end;
                        padding: 8px 0;
                        border-bottom: none;
                    }
                    .item-row-inner-metrics {
                        display: contents;
                    }
                    .desktop-table-header {
                        display: grid;
                        grid-template-columns: 2fr 1fr 1fr 1fr auto;
                        gap: 12px;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #e5e5e5;
                        margin-bottom: 8px;
                    }
                    .mobile-label {
                        display: none !important;
                    }
                }

                /* Responsive Desktop Viewports (>= 1024px) */
                @media (min-width: 1024px) {
                    .main-layout {
                        grid-template-columns: minmax(0, 2.8fr) minmax(0, 1.2fr);
                        gap: 24px;
                    }
                    .sticky-sidebar {
                        position: sticky;
                        top: 24px;
                    }
                }
            `}} />

            {/* Header Content */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', borderBottom: '1px solid #e5e5e5', paddingBottom: '16px', marginBottom: '24px' }}>
                <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#171717', margin: 0 }}>Invoice Form</h1>
                <p style={{ color: '#737373', fontSize: '14px', margin: 0 }}>Create and balance operational transaction parameters</p>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="main-layout">
                    
                    {/* Primary Left Workspaces */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        
                        {/* Section Block 1: Invoice Meta Details */}
                        <div style={cardStyle}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                                <FileText style={{ width: '16px', height: '16px', color: '#2563eb' }} />
                                <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Invoice Details</h2>
                            </div>

                            <div className="invoice-grid-fields">
                                {renderStyledInput("Invoice Number", "invoiceNumber", "text", formData.invoiceNumber, handleInputChange, <Hash style={{ width: '16px', height: '16px' }} />)}
                                {renderStyledInput("Invoice Date", "date", "datetime-local", formData.date, handleInputChange, <Calendar style={{ width: '16px', height: '16px' }} />)}
                                {renderStyledInput("Due Date", "dueDate", "datetime-local", formData.dueDate, handleInputChange, <Calendar style={{ width: '16px', height: '16px' }} />)}
                                
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={labelStyle}>Status</label>
                                    <div style={{ display: 'flex', backgroundColor: '#f5f5f5', padding: '4px', borderRadius: '12px', gap: '4px', minHeight: '42px', boxSizing: 'border-box', alignItems: 'center' }}>
                                        {['Draft', 'Sent', 'Paid'].map(s => (
                                            <button
                                                key={s}
                                                type="button"
                                                onClick={() => setFormData(prev => ({ ...prev, status: s }))}
                                                style={{
                                                    flex: 1,
                                                    padding: '8px 0',
                                                    fontSize: '13px',
                                                    fontWeight: '500',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    backgroundColor: formData.status === s ? '#ffffff' : 'transparent',
                                                    color: formData.status === s ? '#171717' : '#737373',
                                                    boxShadow: formData.status === s ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none'
                                                }}
                                            >
                                                {s}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section Block 2: Profile CRM Information */}
                        <div style={cardStyle}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                                <Building2 style={{ width: '16px', height: '16px', color: '#a855f7' }} />
                                <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Customer Info</h2>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div>
                                    <label style={labelStyle}>Select Customer</label>
                                    <select 
                                        onChange={handleCustomerSelect} 
                                        value={customers.find(c => c.name === formData.customer)?.id || ''} 
                                        style={{...baseInputStyle, height: '42px'}}
                                    >
                                        <option value="">-- Select Customer --</option>
                                        {customers.map(cust => (
                                            <option key={cust.id} value={cust.id}>{cust.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="customer-tier-fields">
                                    {renderStyledInput("Email", "email", "email", formData.email, handleInputChange, <Mail style={{ width: '16px', height: '16px' }} />)}
                                    {renderStyledInput("Phone", "phone", "text", formData.phone, handleInputChange, <PhoneIcon style={{ width: '16px', height: '16px' }} />)}
                                    {renderStyledInput("GSTIN", "gstin", "text", formData.gstin, handleInputChange, <Landmark style={{ width: '16px', height: '16px' }} />)}
                                </div>

                                <div className="address-fields">
                                    {renderStyledTextarea("Billing Address", "billingAddress", formData.billingAddress, handleInputChange)}
                                    {renderStyledTextarea("Shipping Address", "shippingAddress", formData.shippingAddress, handleInputChange)}
                                </div>
                            </div>
                        </div>

                        {/* Section Block 3: Dynamic Matrix Line Items */}
                        <div style={cardStyle}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                                <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Line Items</h2>
                            </div>

                            {/* Responsive Table Headings for Large Monitors */}
                            <div className="desktop-table-header">
                                <span style={labelStyle}>Description</span>
                                <span style={{...labelStyle, textAlign: 'center'}}>Qty</span>
                                <span style={{...labelStyle, textAlign: 'right'}}>Rate</span>
                                <span style={{...labelStyle, textAlign: 'right'}}>Amount</span>
                                <span style={{width: '24px'}} />
                            </div>

                            {/* Self-adapting Form Control Loop */}
                            <div>
                                {formData.items.map((item, index) => (
                                    <div key={index} className="item-row">
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span className="mobile-label" style={labelStyle}>Description</span>
                                            <input 
                                                value={item.description} 
                                                onChange={e => handleItemChange(index, 'description', e.target.value)} 
                                                placeholder="Item dynamic details description..."
                                                style={{ ...baseInputStyle, backgroundColor: '#ffffff' }} 
                                            />
                                        </div>
                                        
                                        <div className="item-row-inner-metrics">
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span className="mobile-label" style={labelStyle}>Qty</span>
                                                <input 
                                                    type="number" 
                                                    value={item.qty} 
                                                    placeholder="0"
                                                    onChange={e => handleItemChange(index, 'qty', e.target.value)} 
                                                    style={{ ...baseInputStyle, textAlign: 'center', backgroundColor: '#ffffff' }} 
                                                />
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span className="mobile-label" style={labelStyle}>Rate</span>
                                                <input 
                                                    type="number" 
                                                    value={item.rate} 
                                                    placeholder="0.00"
                                                    onChange={e => handleItemChange(index, 'rate', e.target.value)} 
                                                    style={{ ...baseInputStyle, textAlign: 'right', backgroundColor: '#ffffff' }} 
                                                />
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column', height: '42px', justifyContent: 'center', textAlign: 'right', minWidth: '60px' }}>
                                                <span className="mobile-label" style={{...labelStyle, marginBottom: 'auto'}}>Amount</span>
                                                <span style={{ fontWeight: '600', color: '#171717', fontSize: '14px' }}>
                                                    ₹{((item.qty || 0) * (item.rate || 0)).toFixed(2)}
                                                </span>
                                            </div>

                                            <button 
                                                type="button" 
                                                onClick={() => removeItem(index)} 
                                                style={{ backgroundColor: '#fef2f2', color: '#ef4444', border: '1px solid #fee2e2', padding: '10px', cursor: 'pointer', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                            >
                                                <X style={{ width: '16px', height: '16px' }} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <button 
                                type="button" 
                                onClick={addItem} 
                                style={{
                                    marginTop: '20px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    gap: '6px', padding: '12px 0', border: '2px dashed #e5e5e5', borderRadius: '12px', fontSize: '13px',
                                    fontWeight: '600', color: '#525252', backgroundColor: '#ffffff', cursor: 'pointer', transition: 'all 0.2s'
                                }}
                            >
                                <Plus style={{ width: '14px', height: '14px' }} />
                                Add New Item
                            </button>
                        </div>
                    </div>

                    {/* Right Sticky Sidebar (Flows into natural order automatically on small screens) */}
                    <div className="sticky-sidebar">
                        <div style={cardStyle}>
                            <h3 style={{ fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#a3a3a3', borderBottom: '1px solid #f5f5f5', paddingBottom: '8px', margin: '0 0 16px 0' }}>Summary Metrics</h3>
                            
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                                    <span style={{ color: '#737373' }}>Subtotal:</span>
                                    <span style={{ fontWeight: '500', color: '#262626' }}>₹{calculateSubtotal().toFixed(2)}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                                    <span style={{ color: '#737373' }}>GST (18%):</span>
                                    <span style={{ fontWeight: '500', color: '#262626' }}>₹{calculateGST().toFixed(2)}</span>
                                </div>
                                
                                <div style={{ borderTop: '1px solid #f5f5f5', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontSize: '14px', fontWeight: '700', color: '#171717' }}>Total Amount:</span>
                                    <span style={{ fontSize: '20px', fontWeight: '700', color: '#2563eb' }}>₹{calculateTotal().toFixed(2)}</span>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px' }}>
                                <button 
                                    type="submit" 
                                    style={{
                                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                        padding: '12px 0', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '12px',
                                        fontWeight: '600', fontSize: '14px', cursor: 'pointer', boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.15)'
                                    }}
                                >
                                    <Save style={{ width: '16px', height: '16px' }} />
                                    Save Invoice
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    );
};

export default InvoicingForm;


// import React, { useState } from 'react';
// import {
//   Plus, ChevronDown, FileText, Building2,
//   Calendar, Hash, Save, X, Mail, Phone as PhoneIcon, Landmark
// } from 'lucide-react';

// // Extended customer data structure matching requirement updates
// const CUSTOMER_DATA = [
//   { id: '1', name: 'John Doe', email: 'john.doe@example.com', phone: '+91 98765 43210', gstin: '27AAAAA1111A1Z1', billingAddress: '123 Main St, Sector 4, Mumbai, MH, 400001', shippingAddress: '123 Main St, Sector 4, Mumbai, MH, 400001' },
//   { id: '2', name: 'Acme Corp', email: 'billing@acme.com', phone: '+91 99999 88888', gstin: '07AAAAA2222B2Z2', billingAddress: 'Tech Park, Block B, New Delhi, DL, 110001', shippingAddress: 'Warehouse 4, Okhla Phase 3, New Delhi, DL, 110020' },
//   { id: '3', name: 'TechStart Inc', email: 'finance@techstart.io', phone: '+91 88888 77777', gstin: '29AAAAA3333C3Z3', billingAddress: 'MG Road, Kormangala, Bengaluru, KA, 560034', shippingAddress: 'MG Road, Kormangala, Bengaluru, KA, 560034' }
// ];

// const PRODUCTS = [
//   { name: 'Teak Divine Noir Wood HZ', code: 'TK-001', hsn: '44079900', unit: 'SQM', rate: 2400, gst: 18 },
//   { name: 'Ash Dyed Velvet Grey', code: 'DY-005', hsn: '44079900', unit: 'SQM', rate: 1850, gst: 18 },
//   { name: 'Smoked Oak Premium', code: 'SM-003', hsn: '44079900', unit: 'SQM', rate: 3100, gst: 18 },
//   { name: 'Herringbone Classic', code: 'HB-002', hsn: '44071500', unit: 'SQM', rate: 2750, gst: 12 },
//   { name: 'Edgewood Natural', code: 'EW-007', hsn: '44071500', unit: 'SQM', rate: 1600, gst: 12 },
// ];

// function createLine(id) {
//   return { id, productName: '', qty: 1, rate: 0, amount: 0 };
// }

// function calcAmount(qty, rate) {
//   return parseFloat((qty * rate).toFixed(2));
// }

//  const InvoicingForm = () => {
//   // Invoice Details State
//   const [invoiceNo] = useState(`INV-${String(Date.now()).slice(-5)}`);
//   const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split('T')[0]);
//   const [dueDate, setDueDate] = useState('');
//   const [status, setStatus] = useState('Draft');

//   // Customer Info State
//   const [selectedCustomerId, setSelectedCustomerId] = useState('');
//   const [customerEmail, setCustomerEmail] = useState('');
//   const [customerPhone, setCustomerPhone] = useState('');
//   const [customerGstin, setCustomerGstin] = useState('');
//   const [billingAddress, setBillingAddress] = useState('');
//   const [shippingAddress, setShippingAddress] = useState('');

//   // Line items state
//   const [items, setItems] = useState([createLine(1)]);
//   const [showProductDrop, setShowProductDrop] = useState(null);

//   // Simple tracking for inputs to mock focus styling behaviors inline
//   const [focusedInput, setFocusedInput] = useState(null);

//   // Handle Select Customer metadata population
//   const handleCustomerChange = (id) => {
//     setSelectedCustomerId(id);
//     const client = CUSTOMER_DATA.find(c => c.id === id);
//     if (client) {
//       setCustomerEmail(client.email);
//       setCustomerPhone(client.phone);
//       setCustomerGstin(client.gstin);
//       setBillingAddress(client.billingAddress);
//       setShippingAddress(client.shippingAddress);
//     } else {
//       setCustomerEmail('');
//       setCustomerPhone('');
//       setCustomerGstin('');
//       setBillingAddress('');
//       setShippingAddress('');
//     }
//   };

//   const selectProduct = (lineId, product) => {
//     setItems(prev => prev.map(item => {
//       if (item.id !== lineId) return item;
//       return {
//         ...item,
//         productName: product.name,
//         rate: product.rate,
//         amount: calcAmount(item.qty, product.rate)
//       };
//     }));
//     setShowProductDrop(null);
//   };

//   const updateLineField = (id, field, value) => {
//     setItems(prev => prev.map(item => {
//       if (item.id !== id) return item;
//       const updatedItem = { ...item, [field]: value };
//       if (field === 'qty' || field === 'rate') {
//         updatedItem.amount = calcAmount(updatedItem.qty, updatedItem.rate);
//       }
//       return updatedItem;
//     }));
//   };

//   const addLine = () => {
//     const newId = items.length > 0 ? Math.max(...items.map(i => i.id)) + 1 : 1;
//     setItems(prev => [...prev, createLine(newId)]);
//   };

//   const removeLine = (id) => {
//     if (items.length === 1) return;
//     setItems(prev => prev.filter(i => i.id !== id));
//   };

//   // Pricing calculations
//   const subtotal = items.reduce((sum, item) => sum + item.amount, 0);
//   const gstAmount = parseFloat((subtotal * 0.18).toFixed(2));
//   const totalAmount = subtotal + gstAmount;

//   // Reusable Shared Inline Styles Base Objects
//   const getInputStyle = (fieldKey, extraStyle = {}) => ({
//     width: '100%',
//     padding: '8px 12px',
//     fontSize: '14px',
//     backgroundColor: focusedInput === fieldKey ? '#ffffff' : '#f9f9f9',
//     border: focusedInput === fieldKey ? '1px solid #2563eb' : '1px solid #e5e5e5',
//     borderRadius: '12px',
//     outline: 'none',
//     transition: 'all 0.2s ease',
//     boxSizing: 'border-box',
//     ...extraStyle
//   });

//   const labelStyle = {
//     display: 'block',
//     fontSize: '12px',
//     fontWeight: '600',
//     color: '#737373',
//     textTransform: 'uppercase',
//     letterSpacing: '0.05em',
//     marginBottom: '4px'
//   };

//   const cardStyle = {
//     backgroundColor: '#ffffff',
//     border: '1px solid #e5e5e5',
//     borderRadius: '16px',
//     padding: '20px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//   };

//   return (
//     <div style={{ padding: '24px', maxWidth: '1024px', margin: '0 auto', backgroundColor: '#fafafa', minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      
//       {/* Header Layout */}
//       <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'between', gap: '16px', borderBottom: '1px solid #f5f5f5', paddingBottom: '16px', marginBottom: '24px' }}>
//         <div style={{ flexGrow: 1 }}>
//           <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#171717', margin: 0 }}>Invoice Form</h1>
//           <p style={{ color: '#737373', fontSize: '14px', margin: '4px 0 0 0' }}>Create and modify client billing configurations</p>
//         </div>
//       </div>

//       {/* Grid Layout Core Wrapper */}
//       <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)', gap: '24px', alignItems: 'start' }}>
        
//         {/* Left Form Payload Column */}
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          
//           {/* Section: Invoice Details */}
//           <div style={cardStyle}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
//               <FileText style={{ width: '16px', height: '16px', color: '#2563eb' }} />
//               <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Invoice Details</h2>
//             </div>

//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
//               <div>
//                 <label style={labelStyle}>Invoice Number</label>
//                 <div style={{ position: 'relative' }}>
//                   <Hash style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#a3a3a3' }} />
//                   <input 
//                     value={invoiceNo} 
//                     readOnly 
//                     style={getInputStyle('invoiceNo', { paddingLeft: '36px', backgroundColor: '#f5f5f5', cursor: 'not-allowed', color: '#737373' })} 
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={labelStyle}>Invoice Date</label>
//                 <div style={{ position: 'relative' }}>
//                   <Calendar style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#a3a3a3', pointerEvents: 'none' }} />
//                   <input
//                     type="date"
//                     value={invoiceDate}
//                     onFocus={() => setFocusedInput('invoiceDate')}
//                     onBlur={() => setFocusedInput(null)}
//                     onChange={e => setInvoiceDate(e.target.value)}
//                     style={getInputStyle('invoiceDate', { paddingLeft: '36px' })}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={labelStyle}>Due Date</label>
//                 <div style={{ position: 'relative' }}>
//                   <Calendar style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#a3a3a3', pointerEvents: 'none' }} />
//                   <input
//                     type="date"
//                     value={dueDate}
//                     onFocus={() => setFocusedInput('dueDate')}
//                     onBlur={() => setFocusedInput(null)}
//                     onChange={e => setDueDate(e.target.value)}
//                     style={getInputStyle('dueDate', { paddingLeft: '36px' })}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={labelStyle}>Status</label>
//                 <div style={{ display: 'flex', backgroundColor: '#f5f5f5', padding: '4px', borderRadius: '12px', gap: '4px' }}>
//                   {['Draft', 'Sent', 'Paid'].map(s => (
//                     <button
//                       key={s}
//                       type="button"
//                       onClick={() => setStatus(s)}
//                       style={{
//                         flex: 1,
//                         padding: '6px 0',
//                         fontSize: '12px',
//                         fontWeight: '500',
//                         borderRadius: '8px',
//                         border: 'none',
//                         cursor: 'pointer',
//                         transition: 'all 0.2s ease',
//                         backgroundColor: status === s ? '#ffffff' : 'transparent',
//                         color: status === s ? '#171717' : '#737373',
//                         boxShadow: status === s ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none'
//                       }}
//                     >
//                       {s}
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Section: Customer Info */}
//           <div style={cardStyle}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
//               <Building2 style={{ width: '16px', height: '16px', color: '#a855f7' }} />
//               <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Customer Info</h2>
//             </div>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//               <div>
//                 <label style={labelStyle}>Select Customer</label>
//                 <div style={{ position: 'relative' }}>
//                   <select
//                     value={selectedCustomerId}
//                     onChange={e => handleCustomerChange(e.target.value)}
//                     onFocus={() => setFocusedInput('selectCustomer')}
//                     onBlur={() => setFocusedInput(null)}
//                     style={getInputStyle('selectCustomer', { appearance: 'none', paddingRight: '40px' })}
//                   >
//                     <option value="">-- Select Customer --</option>
//                     {CUSTOMER_DATA.map(c => (
//                       <option key={c.id} value={c.id}>{c.name}</option>
//                     ))}
//                   </select>
//                   <ChevronDown style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#a3a3a3', pointerEvents: 'none' }} />
//                 </div>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '16px' }}>
//                 <div>
//                   <label style={labelStyle}>Email</label>
//                   <div style={{ position: 'relative' }}>
//                     <Mail style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#a3a3a3' }} />
//                     <input
//                       type="email"
//                       value={customerEmail}
//                       onFocus={() => setFocusedInput('customerEmail')}
//                       onBlur={() => setFocusedInput(null)}
//                       onChange={e => setCustomerEmail(e.target.value)}
//                       placeholder="email@example.com"
//                       style={getInputStyle('customerEmail', { paddingLeft: '36px' })}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Phone</label>
//                   <div style={{ position: 'relative' }}>
//                     <PhoneIcon style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#a3a3a3' }} />
//                     <input
//                       type="text"
//                       value={customerPhone}
//                       onFocus={() => setFocusedInput('customerPhone')}
//                       onBlur={() => setFocusedInput(null)}
//                       onChange={e => setCustomerPhone(e.target.value)}
//                       placeholder="Phone number"
//                       style={getInputStyle('customerPhone', { paddingLeft: '36px' })}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label style={labelStyle}>GSTIN</label>
//                   <div style={{ position: 'relative' }}>
//                     <Landmark style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#a3a3a3' }} />
//                     <input
//                       type="text"
//                       value={customerGstin}
//                       onFocus={() => setFocusedInput('customerGstin')}
//                       onBlur={() => setFocusedInput(null)}
//                       onChange={e => setCustomerGstin(e.target.value)}
//                       placeholder="GSTIN reference"
//                       style={getInputStyle('customerGstin', { paddingLeft: '36px' })}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
//                 <div>
//                   <label style={labelStyle}>Billing Address</label>
//                   <textarea
//                     rows={2}
//                     value={billingAddress}
//                     onFocus={() => setFocusedInput('billingAddress')}
//                     onBlur={() => setFocusedInput(null)}
//                     onChange={e => setBillingAddress(e.target.value)}
//                     placeholder="Enter full invoicing billing address layout"
//                     style={getInputStyle('billingAddress', { resize: 'none' })}
//                   />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Shipping Address</label>
//                   <textarea
//                     rows={2}
//                     value={shippingAddress}
//                     onFocus={() => setFocusedInput('shippingAddress')}
//                     onBlur={() => setFocusedInput(null)}
//                     onChange={e => setShippingAddress(e.target.value)}
//                     placeholder="Enter destination delivery shipping layout address"
//                     style={getInputStyle('shippingAddress', { resize: 'none' })}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Section: Dynamic Products Table Line Engine */}
//           <div style={cardStyle}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
//               <h2 style={{ color: '#262626', fontWeight: '600', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>Items</h2>
//             </div>

//             {/* Main Interactive Table Grid Layout Component */}
//             <div style={{ overflow: 'visible' }}>
//               <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
//                 <thead>
//                   <tr style={{ borderBottom: '1px solid #f5f5f5', color: '#737373', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
//                     <th style={{ textAlign: 'left', paddingBottom: '8px', fontWeight: '500', width: '45%' }}>Description</th>
//                     <th style={{ textAlign: 'center', paddingBottom: '8px', fontWeight: '500', width: '15%' }}>Qty</th>
//                     <th style={{ textAlign: 'right', paddingBottom: '8px', fontWeight: '500', width: '20%' }}>Rate</th>
//                     <th style={{ textAlign: 'right', paddingBottom: '8px', fontWeight: '500', width: '15%' }}>Amount</th>
//                     <th style={{ paddingBottom: '8px', width: '5%' }} />
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {items.map((item) => (
//                     <tr key={item.id}>
//                       <td style={{ padding: '12px 8px 12px 0', position: 'relative' }}>
//                         <input
//                           value={item.productName}
//                           onChange={e => updateLineField(item.id, 'productName', e.target.value)}
//                           onFocus={() => setShowProductDrop(item.id)}
//                           onBlur={() => setTimeout(() => setShowProductDrop(null), 200)}
//                           placeholder="Type description or select catalog item..."
//                           style={{
//                             width: '100%', padding: '6px 8px', fontSize: '14px', boxSizing: 'border-box',
//                             backgroundColor: '#f9f9f9', border: '1px solid #e5e5e5', borderRadius: '8px', outline: 'none'
//                           }}
//                         />
//                         {showProductDrop === item.id && (
//                           <div style={{
//                             position: 'absolute', zIndex: 30, left: 0, top: '100%', marginTop: '4px', width: '100%',
//                             backgroundColor: '#ffffff', border: '1px solid #e5e5e5', borderRadius: '12px',
//                             boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', maxHeight: '192px', overflowY: 'auto'
//                           }}>
//                             {PRODUCTS.filter(p => p.name.toLowerCase().includes(item.productName.toLowerCase())).map(p => (
//                               <button
//                                 key={p.code}
//                                 type="button"
//                                 onMouseDown={() => selectProduct(item.id, p)}
//                                 style={{
//                                   width: '100%', textAlign: 'left', padding: '8px 12px', backgroundColor: 'transparent',
//                                   border: 'none', borderBottom: '1px solid #f5f5f5', cursor: 'pointer', display: 'block'
//                                 }}
//                               >
//                                 <div style={{ fontWeight: '600', color: '#404040', fontSize: '12px' }}>{p.name}</div>
//                                 <div style={{ color: '#a3a3a3', fontSize: '10px' }}>Rate: ₹{p.rate} | Unit: {p.unit}</div>
//                               </button>
//                             ))}
//                           </div>
//                         )}
//                       </td>
//                       <td style={{ padding: '12px 8px' }}>
//                         <input
//                           type="number"
//                           min={1}
//                           value={item.qty || ''}
//                           onChange={e => updateLineField(item.id, 'qty', parseInt(e.target.value) || 0)}
//                           style={{
//                             width: '100%', padding: '6px 8px', fontSize: '14px', boxSizing: 'border-box',
//                             backgroundColor: '#f9f9f9', border: '1px solid #e5e5e5', borderRadius: '8px', outline: 'none', textAlign: 'center'
//                           }}
//                         />
//                       </td>
//                       <td style={{ padding: '12px 8px' }}>
//                         <input
//                           type="number"
//                           min={0}
//                           value={item.rate || ''}
//                           onChange={e => updateLineField(item.id, 'rate', parseFloat(e.target.value) || 0)}
//                           style={{
//                             width: '100%', padding: '6px 8px', fontSize: '14px', boxSizing: 'border-box',
//                             backgroundColor: '#f9f9f9', border: '1px solid #e5e5e5', borderRadius: '8px', outline: 'none', textAlign: 'right'
//                           }}
//                         />
//                       </td>
//                       <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '500', color: '#262626' }}>
//                         ₹{item.amount.toFixed(2)}
//                       </td>
//                       <td style={{ padding: '12px 0 12px 8px', textAlign: 'right' }}>
//                         <button
//                           type="button"
//                           onClick={() => removeLine(item.id)}
//                           disabled={items.length === 1}
//                           style={{
//                             border: 'none', padding: '4px', borderRadius: '6px', cursor: items.length === 1 ? 'not-allowed' : 'pointer',
//                             backgroundColor: 'transparent', color: '#d4d4d4', opacity: items.length === 1 ? 0.3 : 1
//                           }}
//                         >
//                           <X style={{ width: '16px', height: '16px' }} />
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <button
//               type="button"
//               onClick={addLine}
//               style={{
//                 marginTop: '16px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 gap: '6px', padding: '8px 0', border: '2px dashed #e5e5e5', borderRadius: '12px', fontSize: '12px',
//                 fontWeight: '600', color: '#737373', backgroundColor: '#ffffff', cursor: 'pointer', transition: 'all 0.2s'
//               }}
//             >
//               <Plus style={{ width: '14px', height: '14px' }} />
//               Add Item
//             </button>
//           </div>
//         </div>

//         {/* Right Math Computational Receipt Side Column */}
//         <div style={{ position: 'sticky', top: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
//           <div style={cardStyle}>
//             <h3 style={{ fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#a3a3a3', borderBottom: '1px solid #f5f5f5', paddingBottom: '8px', margin: '0 0 16px 0' }}>Summary</h3>
            
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
//                 <span style={{ color: '#737373' }}>Subtotal:</span>
//                 <span style={{ fontWeight: '500', color: '#262626' }}>₹{subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
//                 <span style={{ color: '#737373' }}>GST (18%):</span>
//                 <span style={{ fontWeight: '500', color: '#262626' }}>₹{gstAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
              
//               <div style={{ borderTop: '1px solid #f5f5f5', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <span style={{ fontSize: '14px', fontWeight: '700', color: '#171717' }}>Total:</span>
//                 <span style={{ fontSize: '18px', fontWeight: '700', color: '#2563eb' }}>₹{totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//             </div>

//             <div style={{ paddingTop: '8px', marginTop: '16px' }}>
//               <button
//                 type="button"
//                 style={{
//                   width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
//                   padding: '10px 0', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '12px',
//                   fontWeight: '500', fontSize: '14px', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//                 }}
//               >
//                 <Save style={{ width: '16px', height: '16px' }} />
//                 Save Invoice
//               </button>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }

//  export default InvoicingForm;
